import { render, staticRenderFns } from "./QueueCard2.vue?vue&type=template&id=b0c5ffb0&scoped=true&lang=pug"
import script from "./QueueCard2.vue?vue&type=script&lang=js"
export * from "./QueueCard2.vue?vue&type=script&lang=js"
import style0 from "./QueueCard2.vue?vue&type=style&index=0&id=b0c5ffb0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c5ffb0",
  null
  
)

export default component.exports